import {
    Component, OnInit,
    ViewChild,
    Input
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { EnterNewPasswordComponent } from '../../components/enterNewPassword/enterNewPassword.component';
import { EnterOldPasswordComponent } from '../../components/enterOldPassword/enterOldPassword.component';
import { EnterPhoneComponent } from '../../components/enterPhone/enterPhone.component';
import { EnterSMSCodeComponent } from '../../components/enterSMSCode/enterSMSCode.component';
import { ChangePasswordStepType } from '../../models/enums';
import { AccountService } from '../../services/account.service';


@Component({
    selector: 'app-change-password',
    templateUrl: './changePassword.component.html',
    styleUrls: ['./changePassword.component.scss']
})
export class ChangePasswordComponent implements OnInit {

    private _userIdValue: number;
    private _returnUrl: string;
    private _ticket: string;

    private _userNotFoundErrorTranslate: string;

    ChangePasswordStepType = ChangePasswordStepType;
    public currentStep: ChangePasswordStepType;

    constructor(
        private _translateService: TranslateService,
        private _activatedRoute: ActivatedRoute,
        private _router: Router,
        private accountService: AccountService
    ) {

    }

    @ViewChild('enterOldPasswordComponent') enterOldPasswordComponent: EnterOldPasswordComponent;
    @ViewChild('enterPhoneComponent') enterPhoneComponent: EnterPhoneComponent;
    @ViewChild('enterSMSCodeComponent') enterSMSCodeComponent: EnterSMSCodeComponent;
    @ViewChild('enterNewPasswordComponent') enterNewPasswordComponent: EnterNewPasswordComponent;

    @Input() phoneValueWithRegion: string;

    ngOnInit(): void {

        this._userIdValue = +this._activatedRoute.snapshot.queryParamMap.get('userId');
        this._ticket = this._activatedRoute.snapshot.queryParamMap.get('ticket');
        this._returnUrl = this._activatedRoute.snapshot.queryParamMap.get('ReturnUrl');
        if (!this._returnUrl) {
            this._returnUrl = './login';
        }

        const currentStepStr = this._activatedRoute.snapshot.queryParamMap.get('step');
        if (currentStepStr) {
            this.currentStep = +currentStepStr;
            if (isNaN(this.currentStep)) {
                this.currentStep = ChangePasswordStepType[currentStepStr];
            }
        } else {
            this.currentStep = ChangePasswordStepType.Unknown;
        }

        this._initTranslations();
    }

    private _initTranslations() {
        this._translateService.get(
            [
                'Pages.ChangePassword.UserNotFoundError'
            ])
            .subscribe((result) => {
                this._userNotFoundErrorTranslate = result['Pages.ChangePassword.UserNotFoundError'];
            });
    }


    public changePassword_IsPasswordValid(event: Event): void {
        this.accountService.changePassword_IsPasswordValid(
            this._userIdValue,
            this.enterOldPasswordComponent.oldPasswordValue,
            this.enterOldPasswordComponent.captchaCode)
            .subscribe(response => {

                if (response.error == "CaptchaError") {
                    this.enterOldPasswordComponent.captchaError();
                } else {
                    this.enterOldPasswordComponent.showCaptcha = response.data.showCaptcha;
                    if (!response.success) {
                        this.enterOldPasswordComponent.oldPasswordValue = null;
                        this.enterOldPasswordComponent.errorText = response.error;
                        return;
                    }

                    this._ticket = response.data.ticket;
                    this.currentStep = ChangePasswordStepType.EnterNewPassword;
                }
            });
    }

    public changePassword_SendSMSCode(event: Event): void {
        this.accountService.changePassword_SendSMSCode(
            this.phoneValueWithRegion,
            this.enterPhoneComponent ? this.enterPhoneComponent.captchaCode : this.enterSMSCodeComponent.captchaCode)
            .subscribe(response => {
                if (response.error == "CaptchaError") {
                    if (this.enterPhoneComponent) {
                        this.enterPhoneComponent.captchaError();
                    } else {

                        this.enterSMSCodeComponent.captchaError();
                    }
                } else {
                    if (this.enterSMSCodeComponent) {
                        this.enterSMSCodeComponent.submitProcessing = false;
                    }

                    this.enterSMSCodeComponent.reSendProcessing = false;
                    this.enterSMSCodeComponent.clear();
                    this.enterSMSCodeComponent.startLifeTimeTimer();
                    this.currentStep = ChangePasswordStepType.EnterSMSCode;
                }

            });
    }

    public changePassword_ConfirmSMSCode(event: Event): void {
        this.accountService.changePassword_ConfirmSMSCode(this.phoneValueWithRegion, this.enterSMSCodeComponent.confirmCodeValue)
            .subscribe(response => {
                this.enterSMSCodeComponent.submitProcessing = false;
                if (!response.success) {

                    if (response.data.confirmCodeDeprecated) {
                        this.enterSMSCodeComponent.clear();
                        this.currentStep = ChangePasswordStepType.SendSMSCode;
                        return;
                    }

                    this.enterSMSCodeComponent.errorText = response.error;
                    return;
                }

                this._ticket = response.data.ticket;
                this.currentStep = ChangePasswordStepType.EnterNewPassword;
            });
    }

    public changePassword_SetPassword(event: Event): void {
        this.accountService.changePassword_SetPassword(this._ticket, this.enterNewPasswordComponent.passwordValue)
            .subscribe(response => {
                if (!response.success) {
                    if(response.error == "Timeout"){
                        alert("Время установки нового пароля вышло. Попробуйте снова")
                        this._router.navigate(['./login'], { queryParamsHandling: 'merge' });
                    }
                    this.enterNewPasswordComponent.errorText = response.error;
                    this.enterNewPasswordComponent.evaluatePasswordRules(response.data.ruleList);
                    return;
                }

                this._router.navigate(['./login'], { queryParamsHandling: 'merge' });
            });
    }
}
